import { render, staticRenderFns } from "./EventRegions.vue?vue&type=template&id=111b706a&scoped=true"
import script from "./EventRegions.vue?vue&type=script&lang=js"
export * from "./EventRegions.vue?vue&type=script&lang=js"
import style0 from "./EventRegions.vue?vue&type=style&index=0&id=111b706a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111b706a",
  null
  
)

export default component.exports